import axios from "axios";
export default class FileService {
    getImageSrc(imageName) {
        return axios.get("/image/" + imageName).then(response => {
            if (response.status === 200) {
                const mimeType = this.getMimeType(imageName);
                return `data:${mimeType};base64,${response.data}`;
            }
            return null;
        });
    }
    uploadImage(image) {
        return axios.post("/image/upload", {
            image: image
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            withCredentials: true
        });
    }
    getAttachements() {
        return axios.get('/attachements', {
            withCredentials: true
        });
    }
    uploadAttachement(attachement) {
        return axios.post("/attachement/upload", {
            attachement: attachement
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            withCredentials: true
        });
    }
    deleteAttachement(fileName) {
        return axios.delete(`/attachements/${fileName}`, {
            withCredentials: true
        });
    }
    getMimeType(fileName) {
        const extension = fileName.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'png':
                return 'image/png';
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'gif':
                return 'image/gif';
            case 'svg':
                return 'image/svg+xml';
            case 'webp':
                return 'image/webp';
            default:
                return 'image/png'; // Default to png or image/* if unknown
        }
    }
}
